import React from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';

const PatientInfoCard = ({ patient }) => {
  return (
    <div className="bg-card rounded-xl shadow-elevation-2 border border-border p-4 md:p-6 transition-smooth hover:shadow-elevation-3">
      <div className="flex items-start gap-4">
        <div className="flex-shrink-0">
          <Image
            src={patient?.avatar}
            alt={patient?.avatarAlt}
            className="w-16 h-16 md:w-20 md:h-20 rounded-full object-cover border-2 border-primary/20"
          />
        </div>
        
        <div className="flex-1 min-w-0">
          <div className="flex items-start justify-between gap-2 mb-2">
            <div>
              <h3 className="text-lg md:text-xl font-semibold text-foreground">{patient?.name}</h3>
              <p className="text-sm text-muted-foreground">MRN: {patient?.mrn}</p>
            </div>
            {patient?.status && (
              <span className={`px-3 py-1 rounded-full text-xs font-medium ${
                patient?.status === 'Active' ? 'bg-success/10 text-success' :
                patient?.status === 'Inactive' ? 'bg-muted text-muted-foreground' :
                'bg-warning/10 text-warning'
              }`}>
                {patient?.status}
              </span>
            )}
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 gap-2 md:gap-4 text-sm">
            <div className="flex items-center gap-2 text-muted-foreground">
              <Icon name="Calendar" size={16} />
              <span>DOB: {patient?.dob}</span>
            </div>
            <div className="flex items-center gap-2 text-muted-foreground">
              <Icon name="User" size={16} />
              <span>Age: {patient?.age} | {patient?.gender}</span>
            </div>
            <div className="flex items-center gap-2 text-muted-foreground">
              <Icon name="Phone" size={16} />
              <span>{patient?.phone}</span>
            </div>
            <div className="flex items-center gap-2 text-muted-foreground">
              <Icon name="Mail" size={16} />
              <span className="truncate">{patient?.email}</span>
            </div>
          </div>
          
          {patient?.primaryProvider && (
            <div className="mt-3 pt-3 border-t border-border">
              <div className="flex items-center gap-2 text-sm">
                <Icon name="Stethoscope" size={16} className="text-primary" />
                <span className="text-muted-foreground">Primary Provider:</span>
                <span className="font-medium text-foreground">{patient?.primaryProvider}</span>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default PatientInfoCard;